import styled from 'styled-components';
import { COLORS } from '../../../constants/radar';
export const MainContainer = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 24px;
  flex: 1;
  overflow-y: auto;
  margin-top: 0;
  transition: all 0.3s ease;
`;

export const TemplateGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 24px;
  width: 100%;
  align-items: start;
`;

export const TemplateCard = styled.div`
  background-color: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  transition: all 0.2s;
  align-self: start;

  &:hover {
    background-color: #f1f3f5;
    border-color: #bdbdbd;
  }
`;

export const TemplateCardContent = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  min-height: 150px;
`;

export const TemplateTitle = styled.div`
  color: ${COLORS.PRIMARY};
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
`;

export const TemplateDetailsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-top: 8px;
`;

export const ItalicText = styled.span`
  font-style: italic;
  color: #666;
`;

export const ActionButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 8px;
`; 